import { AnimatePresence, motion } from "framer-motion";
import { useEffect, useState } from "react";
import { useDeviceCapabilities } from "../../hooks/useDeviceCapabilities";
import "./GestureHint.css";

const STORAGE_KEY = "voidex-gesture-hint-dismissed";

export function GestureHint() {
	const { isTouchDevice } = useDeviceCapabilities();
	const [dismissed, setDismissed] = useState(
		() => typeof window !== "undefined" && localStorage.getItem(STORAGE_KEY) === "true",
	);

	useEffect(() => {
		if (!isTouchDevice || dismissed) return;
		const timer = setTimeout(() => {
			setDismissed(true);
			localStorage.setItem(STORAGE_KEY, "true");
		}, 5000);
		return () => clearTimeout(timer);
	}, [isTouchDevice, dismissed]);

	function handleDismiss() {
		setDismissed(true);
		localStorage.setItem(STORAGE_KEY, "true");
	}

	if (!isTouchDevice) return null;

	return (
		<AnimatePresence>
			{!dismissed && (
				<motion.div
					className="gesture-hint glass-panel"
					initial={{ opacity: 0, y: 20 }}
					animate={{ opacity: 1, y: 0 }}
					exit={{ opacity: 0, y: 10 }}
					transition={{ type: "spring", damping: 20, stiffness: 200 }}
					onClick={handleDismiss}
				>
					<div className="gesture-hint-content">
						<span>Pinch to zoom</span>
						<span className="gesture-hint-separator" />
						<span>Drag to pan</span>
						<span className="gesture-hint-separator" />
						<span>Tap a star to explore</span>
					</div>
					<span className="gesture-hint-dismiss">Tap to dismiss</span>
				</motion.div>
			)}
		</AnimatePresence>
	);
}
